/** Generico campo localizzato */
export type LocalizedField<T> = Array<{ language:string, value: T }>; 

/** Campo stringa localizzato */
export type LocalizedString = LocalizedField<string>;